import { Input, Modal, Radio } from 'antd'
import classNames from 'classnames'
import React, { Dispatch, SetStateAction, useState } from 'react'
import { MyBtn } from '~/components/ui/MyBtn'
import { MyModal } from '~/components/ui/MyModal'
import InputArea from '../InputArea'
import styles from './ChatGPTPopup.module.css'

export const ChatGPTPopup: React.FC<{
  visible: boolean
  setVisible: Dispatch<SetStateAction<boolean>>
  onResult: any
  isEnglish: boolean
  setIsEnglish: Dispatch<SetStateAction<boolean>>
}> = ({ visible, setVisible, isEnglish, setIsEnglish, onResult }) => {
  const [text, setText] = useState('')

  // chatgpt使用说明
  const explainAction = () => {
    Modal.info({
      centered: true,
      title: 'AI智能描述 使用说明',
      maskStyle: {
        backgroundColor: 'rgba(0,0,0,0.8)',
      },
      width: 270,
      className: 'hookModal dark',
      content: (
        <div className="text-neutral-400 text-sm mb-2">
          <div className=" text-sm text-[var(--neutral-400)] text-left">
            输入一段中文或英文，由 AI智能描述 生成专业的画面描述；如果不输入内容，会随机生成一段画面描述
          </div>
        </div>
      ),
      okText: '知道了',
      onOk: close => {
        close()
      },
    })
  }

  return (
    <>
      <MyModal
        width={375}
        dark={true}
        open={visible}
        destroyOnClose={true}
        onCancel={v => {
          setText('')
          setVisible(false)
        }}
        footer={null}
        className={styles.top}
        bodyStyle={{
          marginTop: '80px',
          paddingTop: '24px',
          paddingLeft: '16px',
          paddingRight: '16px',
        }}
      >
        <div className="flex justify-between items-center w-full mb-4">
          <div className="flex items-center justify-center">
            <span className="mr-1 text-lg font-semibold text-[var(--neutral-800)]">
              AI智能描述
            </span>
            <img
              src="/images/ai/gpt_desc.svg"
              className="w-4 h-4"
              onClick={explainAction}
              alt=""
            />
          </div>
          <div className="flex justify-center items-center">
            <div className="mr-4">
              <div className={styles.tab}>
                <div
                  className={classNames(styles.tabItem, {
                    selected: !isEnglish,
                  })}
                  onClick={() => {
                    setIsEnglish(false)
                  }}
                >
                  中
                </div>
                <div
                  className={classNames(styles.tabItem, {
                    selected: isEnglish,
                  })}
                  onClick={() => {
                    setIsEnglish(true)
                  }}
                >
                  英
                </div>
              </div>
            </div>
            <div
              className={styles.colse}
              onClick={() => {
                setVisible(false)
                setText('')
              }}
            ></div>
          </div>
        </div>
        <div id="scroll-wrap" className="mb-6">
          <InputArea
            value={text}
            onChange={(e: any) => {
              if (e) {
                setText(e?.target.value ?? '')
              } else {
                setText('')
              }
            }}
            showSuggest={false}
            placeholder="请输入简单的提示语，AI智能描述会生成优化后的画面描述（不输入内容会随机生成一段画面描述）"
            maxLength={200}
          ></InputArea>
        </div>
        <MyBtn
          type="primary"
          onClick={() => {
            onResult(text)

            setVisible(false)
            setText('')
          }}
          size="large"
          block
          className="!p-[2px]"
        >
          <div className=" text-sm font-semibold h-4 text-white mb-1">
            生成画面描述
          </div>
          <div className=" text-[10px] font-normal  text-white mb-1">
            （消耗 1 积分）
          </div>
        </MyBtn>
      </MyModal>
    </>
  )
}
